import { getChatMessages, postSendMessage } from './api.service';
import {
  getChatMessagesRequest,
  getChatMessagesSuccess,
  getChatMessagesFailure,
  postMessageToChatRequest,
  postMessageToChatSuccess,
  postMessageToChatFailure,
} from './actionCreators';
import { generateID } from '../../../../core/helpers/default';

export const fetchSmsMessages = (chatID) => async (dispatch, getState) => {
  try {
    const { globalSelections } = getState();
    dispatch(getChatMessagesRequest());
    const { data } = await getChatMessages(chatID, {
      initiative_id: globalSelections.initiativeId,
      organization_id: globalSelections.organizationId,
    });
    dispatch(getChatMessagesSuccess(data.data));
  } catch ({ message }) {
    dispatch(getChatMessagesFailure(message));
  }
};

export const sendSmsMessage = (chatID, message) => async (dispatch, getState) => {
  try {
    const { globalSelections } = getState();
    dispatch(postMessageToChatRequest());
    await postSendMessage(
      chatID,
      message,
      globalSelections.initiativeId,
      globalSelections.organizationId,
    );
    dispatch(
      postMessageToChatSuccess({
        created_at: new Date(),
        id: generateID(),
        is_read: true,
        message: `${message} To stop receiving these messages, respond with "STOP"`,
        type: 'sent',
      }),
    );
  } catch ({ message }) {
    dispatch(postMessageToChatFailure(message));
  }
};
